import React from 'react'

const Saying = () => {
    return (
        <article className="article">
            <h4>He says:</h4>
            <p>
                This is a golden opportunity for the young people to make their future and reknown themshelves as a "Laure", so i really wanna congratulate all the students who have passed the Examination and wish all of them best of luck for the further physical test.
                And special congrats to these toppers who topped the Examination.
            </p>
        </article>
    )
}

export default Saying
